import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  changePersonalInfoEditingMode,
  changePasswordEditingMode,
  updatePersonalInfoStart,
  loadPaymentOptionsStart,
  deletePaymentOptionStart,
  loadProfileStart,
  changePasswordStart
} from '../../redux/modules/profile'
import {
  selectCurrentLocationWithAddress,
  selectProfile
} from '../../redux/modules/selectors'
import { Article, Card } from '../common/Layout'
import SimpleSpinner from '../common/SimpleSpinner'
import PersonalInformationPanel from './PersonalInformationPanel'
import PaymentOptionsPanel from './PaymentOptionsPanel'
import { loadLocationStart } from '../../redux/modules/location'

export class Profile extends Component {
  componentDidMount() {
    if (this.props.currentUser && !this.props.profile) {
      this.props.loadProfileStart(this.props.currentUser.userId)
      this.props.loadPaymentOptionsStart()
      this.props.loadLocationStart(this.props.currentUser.deliveryLocationId)
    } else if (this.props.currentUser && this.props.profile) {
      this.props.loadPaymentOptionsStart()
      this.props.loadLocationStart(this.props.currentUser.deliveryLocationId)
    }
  }
  componentDidUpdate(prevProps) {
    if (
      !prevProps.currentUser &&
      !prevProps.profile &&
      this.props.currentUser
    ) {
      this.props.loadProfileStart(this.props.currentUser.userId)
      this.props.loadPaymentOptionsStart()
      this.props.loadLocationStart(this.props.currentUser.deliveryLocationId)
    }
  }

  render() {
    const {
      isLoadingProfile,
      paymentOptions,
      isLoadingPaymentOptions,
      isEditingPersonalInfo,
      isChangingPassword,
      changePersonalInfoEditingMode,
      changePasswordEditingMode,
      changePasswordStart,
      updatePersonalInfoStart,
      deletePaymentOptionStart,
      currentUser,
      profile,
      location,
      submitting,
      showSuccess,
      changePasswordFailed,
      isCurrentUserLoading,
      isLocationLoading
    } = this.props
    return (
      <Article>
        <Card>
          <h1 className="title">
            <i className="icon-user" /> User Profile
          </h1>
          {isLoadingProfile || isLocationLoading ? (
            <SimpleSpinner />
          ) : (
            <PersonalInformationPanel
              profile={{ ...currentUser, ...profile }}
              isEditingPersonalInfo={isEditingPersonalInfo}
              isCurrentUserLoading={isCurrentUserLoading}
              changePersonalInfoEditingMode={changePersonalInfoEditingMode}
              isChangingPassword={isChangingPassword}
              changePasswordEditingMode={changePasswordEditingMode}
              changePasswordStart={changePasswordStart}
              updatePersonalInfoStart={updatePersonalInfoStart}
              location={location}
              submitting={submitting}
              success={showSuccess}
              changePasswordFailed={changePasswordFailed}
            />
          )}
          {isLoadingPaymentOptions ? (
            <SimpleSpinner />
          ) : (
            <PaymentOptionsPanel
              paymentOptions={paymentOptions}
              onDeletePaymentOption={deletePaymentOptionStart}
              submitting={submitting}
            />
          )}
        </Card>
      </Article>
    )
  }
}

const mapStateToProps = state => {
  const {
    isLoadingProfile,
    paymentOptions,
    isLoadingPaymentOptions,
    isEditingPersonalInfo,
    isChangingPassword,
    showSuccess,
    changePasswordFailed
  } = state.profile
  const { isLocationLoading } = state.location
  const location = selectCurrentLocationWithAddress(state)
  const { currentUser, submitting, isCurrentUserLoading } = state.user
  const profile = selectProfile(state)

  return {
    isLoadingProfile,
    paymentOptions,
    isLoadingPaymentOptions,
    isEditingPersonalInfo,
    isChangingPassword,
    currentUser,
    profile,
    submitting,
    isLocationLoading,
    location,
    showSuccess,
    changePasswordFailed,
    isCurrentUserLoading
  }
}

const mapDispatchToProps = {
  loadPaymentOptionsStart,
  deletePaymentOptionStart,
  updatePersonalInfoStart,
  changePersonalInfoEditingMode,
  changePasswordEditingMode,
  changePasswordStart,
  loadProfileStart,
  loadLocationStart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Profile)
